module.exports = __webpack_public_path__ + "static/12-dcd8c37854c8af627eebdde7d2eb76fd.jpg";